export function SystemProcess() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            The Digital Age System
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A proven four-step process that transforms your online presence into a customer-generating machine
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            {
              step: '01',
              title: 'Build Modern Website',
              desc: 'Create a conversion-focused website with professional design, fast performance, and strategic layout',
              icon: 'ri-layout-line',
              color: 'from-blue-500 to-blue-600'
            },
            {
              step: '02',
              title: 'Structure for Search',
              desc: 'Implement technical SEO foundation, optimize site architecture, and prepare for maximum visibility',
              icon: 'ri-search-line',
              color: 'from-purple-500 to-purple-600'
            },
            {
              step: '03',
              title: 'Optimize Discovery',
              desc: 'Configure for AI engines, voice search, browser search, and Google Maps to capture all traffic sources',
              icon: 'ri-compass-3-line',
              color: 'from-teal-500 to-cyan-500'
            },
            {
              step: '04',
              title: 'Track & Improve',
              desc: 'Monitor visibility growth, analyze performance data, and continuously optimize for better results',
              icon: 'ri-line-chart-line',
              color: 'from-orange-500 to-red-500'
            }
          ].map((item, index) => (
            <div key={index} className="relative group">
              {/* Step Number */}
              <div className="absolute -top-6 -left-6 w-16 h-16 bg-gray-900 rounded-2xl flex items-center justify-center shadow-lg z-10 group-hover:scale-110 transition-transform">
                <span className="text-white font-bold text-xl">{item.step}</span>
              </div>

              {/* Card */}
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 pt-12 border-2 border-gray-200 hover:border-teal-500 transition-all h-full shadow-lg hover:shadow-xl">
                <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center mb-4`}>
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
              </div>

              {/* Arrow Connector (hidden on last item and mobile) */}
              {index < 3 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                  <i className="ri-arrow-right-line text-teal-500 text-3xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 text-white shadow-xl">
            <h3 className="text-2xl font-bold mb-3">Complete System, Measurable Results</h3>
            <p className="text-lg text-gray-300 max-w-2xl">
              Every step is designed to work together, creating a comprehensive online presence that attracts and converts customers
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}